// Copyright (c) 2016 Deere & Company

import './dealer-search-criteria.scss';
import React, {PropTypes} from 'react';
import DealerSearchInput from './dealer-search-input';
import DealerSearchParams from '../state/dealer-search-params';
import {FormattedMessage} from 'react-intl';
import KeyValuePair from '@deere/cps-it.warranty-model-factory/lib/key-value-pair';
import OptionsDropDown from '../../../shared/components/options-drop-down';

const DealerSearchCriteria = props =>
    <section className='dealer-search-criteria'>
        <div className='primary-criteria'>
            <DealerSearchInput
                identifier='account'
                onInputChange={props.onDealerSearchInput}
                style='dealer-search-account'
                text='ACCOUNT_NUMBER'
                value={props.searchParams.account}
            />
        </div>
        <div className='separator'>
            <FormattedMessage id='OR'/>
        </div>
        <div className='secondary-criteria'>
            <OptionsDropDown
                alwaysCallOnChange={true}
                className='division-drop-down'
                isPlaceholderTranslated={false}
                isRequired={false}
                label='DIVISION'
                onChange={props.onDealerSearchDivisionInput}
                optionDisplayAttributes={['value']}
                optionKey='key'
                options={props.division}
                placeholder='SELECT'
                selectedValue={props.searchParams.division}
            />
            <DealerSearchInput
                identifier='name1'
                onInputChange={props.onDealerSearchInput}
                style='dealer-search-name'
                text='NAME'
                value={props.searchParams.name1}
            />
            <DealerSearchInput
                identifier='city'
                onInputChange={props.onDealerSearchInput}
                style='dealer-search-city'
                text='CITY'
                value={props.searchParams.city}
            />
        </div>
    </section>;

DealerSearchCriteria.displayName = 'DealerSearchCriteria';
DealerSearchCriteria.propTypes = {
    division: PropTypes.arrayOf(PropTypes.instanceOf(KeyValuePair)).isRequired,
    onDealerSearchDivisionInput: PropTypes.func.isRequired,
    onDealerSearchInput: PropTypes.func.isRequired,
    searchParams: PropTypes.instanceOf(DealerSearchParams).isRequired
};

export default DealerSearchCriteria;



// WEBPACK FOOTER //
// ./src/product/dealer-search/components/dealer-search-criteria.js